import { Routes, Route } from "react-router-dom";
import Layout from './components/Layout/Layout';
import Dashboard from './views/Dashboard';
import Dashboard2 from './views/Dashboard/dashboard2';
import Index from "./views/Index";
import Task from './views/Task';
import Chart from './views/Chart';
import Tables from './views/Tables';
import AddTableData from './views/Tables/AddTableData';
import UpdateTableData from './views/Tables/UpdateTableData';
import FilterDataDashboard from '../src/views/Dashboard/FilterDataDashboard';

function App() {
  return (
    <div className="App w-full dark:text-slate-800 h-full dark:bg-slate-800">
      <Layout>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/Dashboard2" element={<Dashboard2 />} />
          <Route path="/task" element={<Task />} />
          <Route path="/Chart" element={<Chart />} />
          <Route path="/Tables" element={<Tables />} />
          <Route path="/Add-Table" element={<AddTableData />} />
          <Route path="/Edit-Table/:id" element={<UpdateTableData />} />
          <Route path="/Filter-Data-Dashboard" element={<FilterDataDashboard />} />
          
        </Routes>
      </Layout>
    </div>
  );
}

export default App;
